// extracted by mini-css-extract-plugin
module.exports = {"container":"_f7eb9342","distinction":"_775ee2d7","title":"_530f0065","icon":"_74e1a76e"};